module.exports = __webpack_public_path__ + "static/media/france.8671cfb4.png";